import { render } from "./AboutEducation.vue?vue&type=template&id=29fe61ad&scoped=true"
import script from "./AboutEducation.vue?vue&type=script&lang=js"
export * from "./AboutEducation.vue?vue&type=script&lang=js"

import "./AboutEducation.vue?vue&type=style&index=0&id=29fe61ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fe61ad"]])

export default __exports__